import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchedCustomer: null,
  createdCustomer: null, // Store newly created customer info
  selectedAddress: null,
  isUserSearched: false,
  pastOrders: null,
  activeOrders: [], // Add activeOrders to store active order details
  editingAddress: null, // Add state to track which address is being edited
  isEditMode: false, // Track whether we're in edit mode
  cateringPastOrders: null, // Store catering-specific past orders
  cateringOrderDetails: null, // Store catering order details
};

const cateringCustomerSlice = createSlice({
  name: "cateringCustomer",
  initialState,
  reducers: {
    setSearchedCustomer: (state, action) => {
      state.searchedCustomer = action.payload;
      state.isUserSearched = true;
    },
    clearSearchedCustomer: (state) => {
      state.searchedCustomer = null;
      state.isUserSearched = false;
    },
    setCreatedCustomer: (state, action) => {
      state.createdCustomer = action.payload;
    },
    setPastOrders: (state, action) => {
      state.pastOrders = action.payload;
    },
    setActiveOrders: (state, action) => {
      // Filter and store only the required fields for active orders
      state.activeOrders = action.payload.filter(order => 
        ["Ready for Dispatch", "Preparing", "On the way", "Submitted", "Accepted", "Delivered"]
        .includes(order.order_status)
      ).map(order => ({
        address_id: order.address_id,
        restaurant_id: order.restaurant_id,
        service_type: order.service_type,
        branch_id: order.branch_id
      }));
    },

    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    setIsUserSearched: (state, action) => {
      state.isUserSearched = action.payload;
    },
    setEditingAddress: (state, action) => {
      state.editingAddress = action.payload;
      state.isEditMode = action.payload !== null;
    },
    setCateringPastOrders: (state, action) => {
      state.cateringPastOrders = action.payload;
    },
    setCateringOrderDetails: (state, action) => {
      state.cateringOrderDetails = action.payload;
    },
    clearAllCateringCustomerData: (state) => {
      // Reset all state to initial values
      state.searchedCustomer = null;
      state.createdCustomer = null;
      state.selectedAddress = null;
      state.isUserSearched = false;
      state.pastOrders = null;
      state.activeOrders = [];
      state.editingAddress = null;
      state.isEditMode = false;
      state.cateringPastOrders = null;
      state.cateringOrderDetails = null;
      state.serviceType = "individual catering";
    },
  },
});

export const {
  setSearchedCustomer,
  clearSearchedCustomer,
  setCreatedCustomer,
  setPastOrders,
  setActiveOrders,
  setSelectedAddress,
  setIsUserSearched,
  setEditingAddress,
  setCateringPastOrders,
  setCateringOrderDetails,
  clearAllCateringCustomerData,
} = cateringCustomerSlice.actions;
export default cateringCustomerSlice.reducer;
